import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Button,
  SimpleGrid,
  useDisclosure,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Center,
  Heading,
  Select,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import AdminSidebar from './AdminSidebar';
import { apiUrl } from '../ApiUrl/ApiUrl';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

function AdminJournalAndBounds() {


  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageFile, setImageFile] = useState(null);
  const [categoriess, setCategoriess] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editingBook, setEditingBook] = useState(null);
  // const booksPerPage = 5;
  const [booksPerPage, setBooksPerPage] = useState(10); // Default rows per page
  const personName = localStorage.getItem("loginsetName");
  const [selectedCategory, setSelectedCategory] = useState("");
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    if (imageFile) {
      formData.append('image', imageFile);
    }
    if (personName) {
      formData.append('person', personName); // ✅ already in use

    }
    try {
      const url = editingBook ? `${apiUrl}/public/updateBookById` : `${apiUrl}/public/savebook`;
      const method = editingBook ? 'PUT' : 'POST';

      if (editingBook) {
        formData.append('id', editingBook.id); // Include the book ID for updating
      }

      const response = await fetch(url, {
        method: method,
        body: formData,
      });

      if (response.ok) {
        alert(editingBook ? 'Product updated successfully!' : 'Product added successfully!');
        e.target.reset();
        setImageFile(null);
        setEditingBook(null); // Reset editing state
        AllBooks(); // Refresh the book list
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding/updating product:', error);
      alert('Check All required Fields Then Please try again later.');
    }
  };
  const AllBooks = () => {
    fetch(`${apiUrl}/public/alljournals`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setBooks(data.reverse());
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching books:', error);
        setLoading(false);
      });
  }

  useEffect(() => {
    AllBooks();
  }, []);
  const handleEdit = (book) => {
    setEditingBook(book); // Set the entire book object for editing
  };
  const handleDelete = (bookId) => {

    fetch(`${apiUrl}/public/deleteById?bid=${bookId}`, {
      method: 'DELETE',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        alert("Deleted Successfully");
        AllBooks();
        return response.json();
      })
      .catch(error => {
        console.error('There was a problem with the delete request:', error);
      });
  };

  const [searchTerm, setSearchTerm] = useState("");
  // Filter books based on search term
  const filteredBooks = books.filter(book =>
    (book.booktitle && book.booktitle.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.maincatname && book.maincatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.subcatname && book.subcatname.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.publisher && book.publisher.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.year && book.year.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.language && book.language.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.author && book.author.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (book.isbn && book.isbn.includes(searchTerm)) ||
    (book.id && book.id.toString().includes(searchTerm))
  );


  // Pagination logic
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = filteredBooks.slice(indexOfFirstBook, indexOfLastBook);


  const totalPages = Math.ceil(books.length / booksPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  useEffect(() => {
    fetch(`${apiUrl}/public/allCategories`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        return response.json();
      })
      .then((data) => setCategories(data))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);


  const handleMainCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    setCategory(selectedCategory);
    setSubCategory("");
    setSubCategories([]); // Clear subcategories when category changes

    fetch(`${apiUrl}/public/getsubCatByCatName?cname=${selectedCategory}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch subcategories");
        }
        return response.json();
      })
      .then((data) => setSubCategories(data))
      .catch((error) => console.error("Error fetching subcategories:", error));
  };



  useEffect(() => {
    // When editingBook changes, update the selected category
    if (editingBook) {
      setSelectedCategory(editingBook.searchcategory);
    }
  }, [editingBook]);

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    // When editingBook changes, set the initial category value
    if (editingBook) {
      setCategory(editingBook.category);  // Set category based on editingBook
    }
  }, [editingBook]);







  return (
    <>



      <Flex h="100%" bg="gray.100">
        <AdminSidebar />
        <Box flex="1" p={4}>
          <Flex justify="space-between" align="center" bg="white" p={4} mb={4} borderRadius="md" shadow="sm">
            <IconButton icon={<FiMenu />} aria-label="Open menu" display={{ base: 'block', md: 'none' }} onClick={onOpen} />
            <Text fontSize="xl" fontWeight="bold">
              Product Management
            </Text>
          </Flex>

          <Box bg="white" p={6} borderRadius="md" shadow="sm">
            <Text fontSize="lg" fontWeight="bold" mb={4}>
              Add New Product
            </Text>

            <form onSubmit={handleFormSubmit} encType="multipart/form-data">
              <SimpleGrid columns={4} spacing={4}>
                <FormControl id="booktitle" isRequired>
                  <FormLabel>Enter Title</FormLabel>
                  <Input type="hidden" placeholder="Enter book id" name="id" defaultValue={editingBook ? editingBook.id : ''} />
                  <Input type="text" placeholder="Enter  title" name="booktitle" defaultValue={editingBook ? editingBook.booktitle : ''} />
                </FormControl>
                <FormControl id="author" >
                  <FormLabel>Author</FormLabel>
                  <Input type="text" placeholder="Enter author name" name="author" defaultValue={editingBook ? editingBook.author : ''} />
                </FormControl>
                <FormControl id="description" >
                  <FormLabel>Description</FormLabel>
                  <Input type="text" placeholder="Enter description" name="description" defaultValue={editingBook ? editingBook.description : ''} />
                </FormControl>
                <FormControl id="image" >
                  <FormLabel>Upload Image</FormLabel>
                  <Input type="file" name="imageFile" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} />
                </FormControl>
                <FormControl id="originalprice" isRequired>
                  <FormLabel>Original Price</FormLabel>
                  <Input type="number" placeholder="Enter original price" name="originalprice" defaultValue={editingBook ? editingBook.originalprice : ''} />
                </FormControl>
                <FormControl id="descprice" isRequired>
                  <FormLabel>Discounted Price</FormLabel>
                  <Input type="number" placeholder="Enter discounted price" name="descprice" defaultValue={editingBook ? editingBook.descprice : ''} />
                </FormControl>
                <FormControl id="format" >
                  <FormLabel>Format</FormLabel>
                  <Input type="text" placeholder="Enter Format" name="format" defaultValue={editingBook ? editingBook.format : ''} />
                </FormControl>
                <FormControl id="pages" >
                  <FormLabel>Pages</FormLabel>
                  <Input type="number" placeholder="Enter Pages" name="pagess" defaultValue={editingBook ? editingBook.pagess : ''} />
                </FormControl>
                <FormControl id="publisher" >
                  <FormLabel>Publisher Name</FormLabel>
                  <Input type="text" placeholder="Enter Publisher Name" name="publisher" defaultValue={editingBook ? editingBook.publisher : ''} />
                </FormControl>
                <FormControl id="language" >
                  <FormLabel>Book Language</FormLabel>
                  <Input type="text" placeholder="Enter Book Language" name="language" defaultValue={editingBook ? editingBook.language : ''} />
                </FormControl>
                <FormControl id="isbn" >
                  <FormLabel>ISBN</FormLabel>
                  <Input type="text" placeholder="Enter ISBN" name="isbn" defaultValue={editingBook ? editingBook.isbn : ''} />
                </FormControl>
                <FormControl id="hsn" >
                  <FormLabel>HSN Number</FormLabel>
                  <Input type="number" placeholder="Enter HSN" name="hsn" defaultValue={editingBook ? editingBook.hsn : ''} />
                </FormControl>
                <FormControl id="year" >
                  <FormLabel>Publish Year</FormLabel>
                  <Input type="text" placeholder="Enter Publish Year" name="year" defaultValue={editingBook ? editingBook.year : ''} />
                </FormControl>
                <FormControl id="volume" >
                  <FormLabel>Book Volume</FormLabel>
                  <Input type="text" placeholder="Enter Book Volume" name="volume" defaultValue={editingBook ? editingBook.volume : ''} />
                </FormControl>
                <FormControl id="boundvolume" >
                  <FormLabel>Bound Volume</FormLabel>
                  <Input type="text" placeholder="Enter Bound Volume" name="boundvolume" defaultValue={editingBook ? editingBook.boundvolume : ''} />
                </FormControl>
                <FormControl id="boundyear" >
                  <FormLabel>Bound Year</FormLabel>
                  <Input type="text" placeholder="Enter Bound Year" name="boundyear" defaultValue={editingBook ? editingBook.boundyear : ''} />
                </FormControl>
                <FormControl id="dimension" >
                  <FormLabel>Dimension</FormLabel>
                  <Input type="text" placeholder="Enter Dimension" name="dimension" defaultValue={editingBook ? editingBook.dimension : ''} />
                </FormControl>
                <FormControl id="publishercode" >
                  <FormLabel>Publisher Code</FormLabel>
                  <Input type="text" placeholder="Enter Publisher Code" name="publishercode" defaultValue={editingBook ? editingBook.publishercode : ''} />
                </FormControl>
                <FormControl id="maincatname" isRequired>
                  <FormLabel>Select Category</FormLabel>
                  <select name="maincatname" value={category} onChange={handleMainCategoryChange}>
                    <option value="">Select Category</option>
                    <option value="Journals">Journals & Bound Volumes</option>


                    {/* {categories.length > 0 ? (
            categories.map((cat) => (
              <option key={cat.catId} value={cat.maincatname}>
                {cat.maincatname}
              </option>
            ))
          ) : (
            <option value="">No categories available</option>
          )} */}
                  </select>
                </FormControl>

                <FormControl id="subcatname" isRequired>
                  <FormLabel>Select Sub Category</FormLabel>
                  <select name="subcatname" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
                    <option value="">Select Sub Category</option>
                    {subCategories.length > 0 ? (
                      subCategories.map((sub) => (
                        <option key={sub.subcatId} value={sub.subcatname}>
                          {sub.subcatname}
                        </option>
                      ))
                    ) : (
                      <option value="">No subcategories available</option>
                    )}
                  </select>
                </FormControl>
                <FormControl id="searchcategory" isRequired >
                  <FormLabel>Select Search Category</FormLabel>
                  <select name="searchcategory" value={subCategory} onChange={(e) => setSubCategory(e.target.value)}>
                    <option value="">Select Search Category</option>
                    {subCategories.length > 0 ? (
                      subCategories.map((sub) => (
                        <option key={sub.subcatId} value={sub.subcatname}>
                          {sub.subcatname}
                        </option>
                      ))
                    ) : (
                      <option value="">No subcategories available</option>
                    )}
                  </select>
                </FormControl>
                <FormControl id="jurisdiction" >
                  <FormLabel>Add Jurisdiction</FormLabel>
                  <Input type="text" placeholder="Enter Jurisdiction" name="jurisdiction" defaultValue={editingBook ? editingBook.jurisdiction : ''} />
                </FormControl>





                <FormControl id="recomandate"  >
                  <FormLabel>Recomendate </FormLabel>
                  <select name="recomandate">
                    <option value="0">No</option>
                    <option value="1">Yes</option>

                  </select>
                </FormControl>






                <FormControl id="yearlybond"  >
                  <FormLabel>Yearly Journal</FormLabel>
                  <select name="yearlybond">
                    <option>Select Yearly Journal</option>

                    <option value="2025">2023</option>
                    <option value="2025">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>


                  </select>
                </FormControl>




              </SimpleGrid>
              <VStack mt={4} align="stretch">
                <Button type="submit" colorScheme="teal" width="full" >
                  Add Product
                </Button>
              </VStack>
            </form>
          </Box>
        </Box>

      </Flex>

      <Box p={3}>
        <Heading as="h2" size="lg" mb={4}>Journal & Bounds List</Heading>
        <div className='flex gap-5'>
          <FormControl id="search" className="py-1" >
            <FormLabel>Search Products</FormLabel>
            <Input

              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              width="300px"
            />
          </FormControl>


        </div>



        {loading ? (
          <Center>
            <Spinner size="sm" />
          </Center>
        ) : (
          <>
            <TableContainer>
              <Flex justify="space-between" mb={4}>

                <Select
                  width="150px"
                  value={booksPerPage}
                  onChange={(e) => {
                    setBooksPerPage(Number(e.target.value));
                    setCurrentPage(1); // Reset to first page on change
                  }}
                >
                  <option value="5">5 per page</option>
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="50">50 per page</option>
                </Select>
                <h1>Total Journals/Bounds : {currentBooks.length}</h1>


                {/* <Flex gap={2}>
          <Button onClick={prevPage} isDisabled={currentPage === 1}>
            Previous
          </Button>
          <Button onClick={nextPage} isDisabled={currentPage === totalPages}>
            Next
          </Button>
        </Flex> */}
              </Flex>
              <Table variant="striped" colorScheme="teal">
                <Thead>
                  <Tr>
                    <Th>Actions</Th>
                    <Th>Entry By</Th>
                    <Th>ID</Th>
                    <Th>Title</Th>
                    <Th>Author</Th>
                    <Th>Publication Year</Th>
                    <Th>Original Price</Th>
                    <Th>Descounted Price</Th>
                    <Th>Format</Th>
                    <Th>Book Pages</Th>
                    <Th>Publisher</Th>
                    <Th>Language</Th>
                    <Th>ISBN</Th>
                    <Th>Publisher Code</Th>
                    <Th>Category</Th>
                    <Th>Sub Category</Th>
                    <Th>Search Category</Th>
                    <Th>Jurisdiction</Th>
                    <Th>Volume</Th>
                    <Th>Bound Volume</Th>
                    <Th>Bound Year</Th>
                    <Th>Yearly Journal</Th>

                  </Tr>
                </Thead>
                <Tbody>
                  {currentBooks.map(book => (
                    <Tr key={book.id}>
                      <Td>
                        <Flex gap={2}>
                          <IconButton
                            aria-label="Edit Book"
                            icon={<FiEdit />}
                            // onClick={() => handleEdit(book)}
                            onClick={() => {
                              handleEdit(book);
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }}
                          />
                          <IconButton
                            aria-label="Delete Book"
                            icon={<FiTrash2 />}
                            colorScheme="red"
                            onClick={() => handleDelete(book.id)}
                          />
                        </Flex>
                      </Td>
                      <Td>{book.person ? book.person : 'kstar'}</Td>
                      <Td>{book.id}</Td>
                      <Td>{book.booktitle}</Td>
                      <Td>{book.author}</Td>
                      <Td>{book.year}</Td>
                      <Td>{book.originalprice}</Td>
                      <Td>{book.descprice}</Td>
                      <Td>{book.format}</Td>
                      <Td>{book.pagess}</Td>
                      <Td>{book.publisher}</Td>
                      <Td>{book.language}</Td>
                      <Td>{book.dimension}</Td>
                      <Td>{book.publishercode}</Td>
                      <Td>{book.maincatname}</Td>
                      <Td>{book.subcatname}</Td>
                      <Td>{book.searchcategory}</Td>
                      <Td>{book.jurisdiction}</Td>
                      <Td>{book.volume}</Td>
                      <Td>{book.boundvolume}</Td>
                      <Td>{book.boundyear}</Td>
                      <Td>{book.yearlybond}</Td>

                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
            <Flex justify="space-between" mt={4}>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
                Previous
              </Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next
              </Button>
            </Flex>
          </>
        )}
      </Box>
    </>

  );
}

export default AdminJournalAndBounds;
